import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The following table lists all the resources that are available to the customers defined with a company. To visualize the resource hierarchy, log in to a store as the Company Admin and select `}<strong parentName="p">{`Roles and Permissions`}</strong>{`, then click the `}<strong parentName="p">{`Edit`}</strong>{` action next to the Default User role.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Display name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Resource name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::index`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Sales`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Sales::all`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Allow Checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Sales::place_order`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Use Pay On Account method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Sales::payment_account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View orders`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Sales::view_orders`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View orders of subordinate users`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Sales::view_orders_sub`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Quotes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_NegotiableQuote::all`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_NegotiableQuote::view_quotes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Request, Edit, Delete`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_NegotiableQuote::manage`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Checkout with Quote`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_NegotiableQuote::checkout`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View quotes of subordinate users`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_NegotiableQuote::view_quotes_sub`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` Order Approvals`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrder::all`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` View My Purchase Orders`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrder::view_purchase_orders`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View for subordinates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrder::view_purchase_orders_for_subordinates`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View for all company`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrder::view_purchase_orders_for_company`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Auto-approve POs created within this role`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrder::autoapprove_purchase_order`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Approve Purchase Orders without other approvals`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrderRule::super_approve_purchase_order`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` View Approval Rules`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrderRule::view_approval_rules`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Create, Edit and Delete`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_PurchaseOrderRule::manage_approval_rules`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Company Profile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::view`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Account Information (View)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::view_account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Edit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::edit_account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Legal Address (View)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::view_address`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Edit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::edit_address`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Contacts (View)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::contacts`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Payment Information (View)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::payment_information`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` Shipping Information (View)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::shipping_information`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Company User Management`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::user_management`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View roles and permissions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::roles_view`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Manage roles and permissions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::roles_edit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` View users and teams`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::users_view`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` `}{` `}{` Manage users and teams`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::users_edit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` Company credit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::credit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{` `}{` `}{` `}{` `}{` `}{` view`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento_Company::credit_history`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      